/*
 * DATA SOURCES
 *
 * Single points of definition for all data sources that this app will use.  All endpoints should use DeferredModules
 * from the loader module to allow for gradual App delivery to the browser.
 *
 * DEV NOTE: Calling deferredModule in this way is required (rather than deferring until later) because WebPack does
 *           static analysis for dynamic require.ensure( ... ) calls and so the string literal for the module path must
 *           be a part of the call chain.
 */

import { Map } from 'immutable';
import { DATA_SOURCE_TYPES } from '@artsman/ams-loader';

const dataSources = Map({
  me: { type: DATA_SOURCE_TYPES.ITEM },

  dashboard_layouts: { type: DATA_SOURCE_TYPES.COLLECTION },
  widget_types: { type: DATA_SOURCE_TYPES.COLLECTION },
  dashboard_links: { type: DATA_SOURCE_TYPES.COLLECTION },
  widget_links: { type: DATA_SOURCE_TYPES.COLLECTION },
  dashboards: { type: DATA_SOURCE_TYPES.COLLECTION },
  dashboardsNew: { type: DATA_SOURCE_TYPES.ITEM, readOnly: true },
  widgets: { type: DATA_SOURCE_TYPES.COLLECTION },

  index: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  address_links: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  addresses: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  assigned_report_cards: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  calendar_events: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  calendar_filters: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  cart_details: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  carts: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  city_lookup: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  comments: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  commissions: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  contact_links: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  contact_schedules: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  contacts: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  correspondence: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  correspondence_links: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  coupon_headers: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  currency_conversions: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  daily_sales_summaries: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  daily_usage: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  documents: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  donation_campaigns: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  donation_receipts: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  donations: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  donor_search: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  employees: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  events: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  execution_logs: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  fee_types: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  fees: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  giving_level_details: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  giving_level_summaries: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  giving_levels: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  gl_accounts: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  gl_details: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  gl_headers: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  households: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  jobs: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  mail_list_links: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  mail_lists: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  maps: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  marketing: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  member_assigned_cards: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  member_cards: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  membership_types: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  memberships: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  merchants: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  notifications: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  orders: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  outlets: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  package_details: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  package_headers: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  patron_assets: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  patrons: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  payments: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  performances: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  plugins: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  press: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  price_codes: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  project_holidays: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  project_markers: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  project_relations: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  project_suspensions: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  project_working_hours: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  promotions: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  recognition_details: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  recognitions: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  relationships: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  report_card_details: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  report_card_template_details: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  report_card_templates: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  report_cards: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  resource_assemblies: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  resource_links: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  resources: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  sales_rule_details: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  sales_rules: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  seasons: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  seating_preferences: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  seats: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  security_access: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  security_endpoints: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  statistics: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  subscriptions: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  supervisors: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  system: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  task_participants: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  tax_rates: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  ticket_faces: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  tickets: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  transactions: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  venues: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  volunteer_availabities: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  volunteer_billing_details: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  volunteer_history: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  volunteers: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true },
  web_logs: { type: DATA_SOURCE_TYPES.COLLECTION, readOnly: true }
});

export const dataSourceKeys = dataSources.keySeq().sort().toJS();

export default dataSources;